export default "__VITE_ASSET__Bhp2KaKH__"